"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const AbstractGroupingLayout_1 = tslib_1.__importDefault(require("./AbstractGroupingLayout"));
class SimpleGroupingLayout extends AbstractGroupingLayout_1.default {
    constructor(dataManager, gridConfig, table, comparator, presenter, initiallyExpanded, enableExpandCollaps) {
        super(initiallyExpanded);
        this.presenter = presenter;
        this.enableExpandCollaps = enableExpandCollaps;
        this.dataManager = dataManager;
        this.gridConfig = gridConfig;
        this.table = table;
        this.comparator = comparator;
    }
    renderGroupHeader(ctx, column, data) {
        ctx.html(`<span>${this.presenter.toString(data[0])} (${data.length})</span>`);
    }
    getGroupHeaderColSpan(row, column) {
        if (column === 0) {
            const numberOfExpandColumns = this.enableExpandCollaps ? 1 : 0;
            // Expand/collaps is enabled by making room for expand/collaps column
            return this.gridConfig.getNumberOfColumns() - numberOfExpandColumns;
        }
        else {
            throw new Error("Colspan requested for unexpected column");
        }
    }
}
exports.default = SimpleGroupingLayout;
//# sourceMappingURL=SimpleGroupingLayout.js.map